import { startAuthFlow } from '../api/UnifiedAccountApi';
import { AuthenticateError } from '../../shared/types/authErrors';
import { createBuildAuthPayload, createAuthorizeUrlFetcher, createReconnectAuthorizeUrlFetcher, createFinishNewAccountHandler, createFinishReconnectHandler, createFinishMigrationReconnectHandler, resolveOAuthScopeSet } from './authFlowConfigHelpers';
async function startAndValidateAuthFlow(portalId, appId, appName) {
  const response = await startAuthFlow(portalId, {
    appId,
    appName
  });
  if (response['@result'] !== 'OK') {
    throw new AuthenticateError(response.localizedErrorMessage, response.extraDetailsMessage);
  }
  return response;
}
export function createAuthConfigFetchers(config) {
  const {
    portalId,
    appId,
    appName,
    appIcon = '',
    oAuthScope,
    oAuthScopes,
    mcpParams,
    incremental,
    customParams
  } = config;
  const resolvedOAuthScopeSet = resolveOAuthScopeSet(oAuthScope, oAuthScopes);
  return {
    forNewAccount: async () => {
      const {
        authenticationFlow,
        sessionId,
        appName: resolvedAppName
      } = await startAndValidateAuthFlow(portalId, appId, appName);
      return {
        appName: resolvedAppName,
        appIcon,
        appId,
        oAuthScopeSet: resolvedOAuthScopeSet,
        mcpParams: mcpParams !== null && mcpParams !== void 0 ? mcpParams : undefined,
        authFlow: Object.assign({}, authenticationFlow, {
          sessionId
        }),
        buildAuthPayload: createBuildAuthPayload(appId),
        makeAuthorizeUrlDescriptor: createAuthorizeUrlFetcher({
          portalId,
          appId,
          sessionId,
          customParams
        }),
        finishAuthFlow: createFinishNewAccountHandler({
          portalId,
          appId,
          customParams
        })
      };
    },
    forReconnect: async accountId => {
      const {
        authenticationFlow,
        sessionId,
        appName: resolvedAppName
      } = await startAndValidateAuthFlow(portalId, appId, appName);
      return {
        appName: resolvedAppName,
        appIcon,
        oAuthScopeSet: resolvedOAuthScopeSet,
        mcpParams: mcpParams !== null && mcpParams !== void 0 ? mcpParams : undefined,
        authFlow: Object.assign({}, authenticationFlow, {
          sessionId
        }),
        buildAuthPayload: createBuildAuthPayload(appId),
        makeAuthorizeUrlDescriptor: createReconnectAuthorizeUrlFetcher({
          portalId,
          accountId,
          sessionId,
          incremental,
          customParams
        }),
        finishAuthFlow: createFinishReconnectHandler({
          portalId,
          accountId,
          incremental,
          customParams
        })
      };
    },
    forMigrationReconnect: async oAuthorAccountId => {
      const {
        authenticationFlow,
        sessionId,
        appName: resolvedAppName
      } = await startAndValidateAuthFlow(portalId, appId, appName);
      return {
        appName: resolvedAppName,
        appIcon,
        oAuthScopeSet: resolvedOAuthScopeSet,
        mcpParams: mcpParams !== null && mcpParams !== void 0 ? mcpParams : undefined,
        authFlow: Object.assign({}, authenticationFlow, {
          sessionId
        }),
        buildAuthPayload: createBuildAuthPayload(appId),
        makeAuthorizeUrlDescriptor: createAuthorizeUrlFetcher({
          portalId,
          appId,
          sessionId,
          customParams
        }),
        finishAuthFlow: createFinishMigrationReconnectHandler({
          portalId,
          appId,
          oAuthorAccountId,
          customParams
        })
      };
    }
  };
}